import { useState } from "react";
import { chakra } from "@chakra-ui/react";

export default function ExpandableSection({ content, trimLength = 150, color = "#4d8db8" }) {
  const [expanded, setExpanded] = useState(false);
  const toggle = () => setExpanded(!expanded);

  if (!Array.isArray(content)) {
    if (content.length < trimLength) {
      return content;
    } else {
      return (
        <>
          {expanded ? content : content.substring(0, trimLength)}
          <chakra.span cursor="pointer" color={color} fontStyle="italic" onClick={toggle}>
            {!expanded && "... read more!"}
            {expanded && " « read less"}
          </chakra.span>
        </>
      );
    }
  } else {
    return (
      <>
        {content[0]}
        {expanded && content[1]}
        <span className="pLink" style={{ color: color, fontStyle: "italic" }} onClick={toggle}>
          {!expanded && "... read more!"}
          {expanded && " « read less"}
        </span>
      </>
    );
  }
}
